export const DefaultGuid: string = "00000000-0000-0000-0000-000000000000";

export const CALCULATEDREGEXP = /\[([A-Za-z0-9_*%/+-]*)\]/gm;
export const CALCREGEXP = /\[(.*?)\]/gm;
export const COMMONREGEXP = /[\\/:*?"<>|]/;
export const NETWORKSHARINGREGEXP = /[({~`!$%^*[\]=|;'",?<>})]/;
export const CALCULATEDID = "b2647929-08dd-42b6-b23c-30ed31c360ff";

export const CHANGE_EVENT = "change";
export const NOTIFICATION_TIMEOUT = 0;
export const UI_NOTIFICATION_TIMEOUT = 3000;
export const SEARCH_LENGTH = 1;

export const PRODUCT_NAME = "L&W Lab Management System";
export const VERSION = "v3.5.0"

// Path Variable
export const PATH_PROPERTY = "property";
export const PATH_GRADE = "grade";
export const PATH_SOURCE = "source";
export const PATH_PRODUCT = "product";
export const PATH_MANAGE_INSTRUMENT = "manageinstrument";
export const PATH_TEST_PLAN = "testplan";
export const PATH_INSTRUMENT_TYPE = "instrumenttype";
export const PATH_INSTRUMENT = "instrument";
export const PATH_INSTRUMENT_STATION = "instrumentstation";
export const PATH_SAMPLE = "sample";
export const MODULE_SAMPLE_NEW = "SampleNew";
export const SAMPLE_CREATE_URL_NEW = "/samplenew/createNew";
export const PATH_ACCOUNT_MANAGEMENT = "accountmanagement";
export const PATH_USERS = "users";
export const PATH_ROLES_AND_PERMISSIONS = "rolesandpermissions";
export const INITIAL_PATH_ROLES_AND_PERMISSIONS =
  "AccountManagement/Roles&Permissions";
export const PATH_REPORT_TEMPLATE = "reporttemplate";
export const PATH_UTILITY = "utility";
export const PATH_BACKUP_AND_RESTORE = "backup&restore";
export const PATH_INSTRUMENT_DASHBOARD = "instrumentdashboard";
export const PATH_SCANNER = "scanner";

// Menu Variable
export const MENU_PROPERTY = "Property";
export const MENU_ATTRIBUTE = "Attribute";
export const MENU_TRENDS = "Trends";
export const MENU_TREND = "Trend";
export const MENU_GRADE = "Grade";
export const MENU_PRODUCT = "Product";
export const MENU_SOURCE = "Source";
export const MENU_MANAGE_INSTRUMENT = "Manage Instrument";
export const MENU_SAMPLE = "Sample";
export const MENU_REPORT_TEMPLATE = "Report Template";
export const MENU_TREND_ANALYSIS = "Trend Analysis";
export const MENU_ACCOUNT_MANAGEMENT = "Account Management";
export const MENU_UTILITY = "Utility";
export const MENU_INSTRUMENT_DASHBOARD = "Instrument Dashboard";
export const MENU_SCANNER = "Scanner";
export const MENU_MODULES = "Modules";
export const MENU_DASHBOARD = "Dashboard";
export const MENU_CONFIG = "Configuration";
export const MENU_SAMPLE_MEASUREMENT = "Sample Measurement";
export const MENU_INSTRUMENTMEASUREMENT = "Instrument Measurement";
export const MENU_MEASUREMENT_XML = "Measurement XML";
export const MENU_MEASUREMENT_XLS = "Measurement XLS";
export const MENU_EXPORT_SAMPLE = "Export Sample";
export const MENU_EXPORT_MEASUREMENT = "Export Measurement";
export const MENU_SAMPLE_XML = "Sample XML";
export const MENU_DOWNLOAD_LOGS = "Download Logs";

// SubMenu Variable
export const SUBMENU_INSTRUMENT = "Instrument";
export const SUBMENU_INSTRUMENT_TYPE = "Instrument Type";
export const SUBMENU_INSTRUMENT_STATION = "Instrument Station";
export const SUBMENU_TEST_PLAN = "Test Plan";
export const SUBMENU_USERS = "Users";
export const SUBMENU_ROLES_AND_PERMISSIONS = "Roles & Permissions";
export const SUBMENU_BACKUP_AND_RESTORE = "Backup and Restore";
export const SUBMENU_LOGS = "Logs";
export const SUBMENU_LICENSE_MANAGEMENT = "License Management";
export const SUBMENU_SETTINGS = "Settings";
export const SUBMENU_SCANNER = "Scanner";
// Dispatcher constants
export const COMMON = "create/viewAll/delete";
export const EDIT = "Edit";
export const NEW = "New";
export const ENABLE = "Enable";
export const DISABLE = "Disable";
export const VIEW_ALL = "View All";
export const CREATE = "Create";
export const SCAN = "Scan";
export const DELETE = "Delete";
export const ASSOCIATE = "Associate";
export const SHOW_NOTIFICATIONS = "showNotifications";
export const UPDATE_NAVIGATION_HEADER = "updateNavigationHeader";
export const SET_ACTIVE = "setActive";
export const SUBMIT_DISABLED = "submitDisabled";
export const UPDATE_SELECTED_INSTRUMENTS_INSTRUMENTTYPE =
  "updateSelectedInstrumentsInstrumentType";
export const EXPORT = "Export";
export const REPORT = "Report";
export const MORE = "More";
export const NO = "No";
export const REQUIRED = "*";
export const SAMPLE_AL1 = "Measurement AL1";
export const IP_ADDRESS = "IP Address";
export const PORT = "Port";



// Label Constants
export const LABEL_DESCRIPTION = "Description";
export const LABEL_EMAIL = "Email";
export const LABEL_REMARKS = "Remarks";
export const LABEL_PROPERTYID = "Property ID";
export const LABEL_TYPE = "Property Type";
export const LABEL_SELECT_TYPE = "Select the Type";
export const TYPE = "Type";
export const LABEL_UNIT = "Unit";
export const LABEL_AVG = "Avg";
export const LABEL_DECIMALS = "Decimal";
export const LABEL_SUMMARY = "Summary";
export const LABEL_STATE = "State";
export const LABEL_STATUS = "Status";
export const LABEL_REELNUMBER = "Reel No.";
// export const LABEL_DATECREATED = "Date Created";
export const LABEL_DATECREATED = "Date";
export const LABEL_SETID = "Set ID";
export const LABEL_ORDERID = "Order ID";
export const LABEL_CODEID = "Code ID";
export const FORMULA = "Formula";
export const PRODUCT_CODE = "Product Code";
export const SOURCE_CODE = "Source Code";
export const INPUT_DEFINITION = "Input Definition";
export const LABEL_VARIABLE = "Variable";
export const LABEL_PROPERTY_ATTRIBUTE = "Property Attribute";
export const LABEL_SERIES = "count/position/series";
export const LABEL_VALUE = "Value";
export const LABEL_PICK_SOURCE = "Pick Source";
export const LABEL_PICK_POSITION = "Pick Position";
export const LABEL_PICK_VALUES = "Pick Values";
export const LABEL_SELECT = "Select";
export const LABEL_PICK = "Pick";
export const LABEL_ADD = "Add";
export const LABEL_DIRECTIONS = "direction(s)";
export const LABEL_DIRECTION = "Direction";
export const LABEL_DIRECTION_CHANGE = "Direction change";
export const LABEL_INSTRUMENT_TYPE_CHANGE = "Instrument type change";
export const LABEL_SELECTION_CHANGE = "Selection change";
export const LABEL_FORMULA_EXECUTION = "Formula Execution";
export const LABEL_AUTO = "Auto";
export const LABEL_COUNT = "Count";
export const LABEL_POSITION = "Position";
export const LABEL_SERIE = "Series";
export const LABEL_PROPERTYNAME = "PROPERTYNAME";
export const LABEL_CAPS_UNIT = "UNITCAPS";
export const LABEL_MEAN = "MEAN";
export const LABEL_CAPS_POSITION = "POSITION";
export const LABEL_POSITIONMEAN = "POSITIONMEAN";
export const LABEL_CAPS_DIRECTION = "DIRECTIONS";
export const LABEL_CAPS_COUNT = "COUNT";
export const LABEL_CAPS_VALUE = "VALUE";
export const LABEL_PROPERTIES = "Properties";
export const LABEL_GRADE_QUALITY_SPECIFICATIONS = "Grade Quality Specifications";
export const NO_TESTPLAN_SELECTED = "No Test Plan Selected";
export const INSTRUMENTS = "Instruments";
export const LABEL_INSTRUMENTS_LIST = "Instruments list";
export const NO_INSTRUMENT_SELECTED = "No Instrument Selected";
export const NO_PROPERTIES_SELECTED = "No Properties Selected";
export const ONE_PROPERTY_ASSOCIATED = "1 Property Associated";
export const NO_PROPERTIES_ASSOCIATED = "No Properties Associated";
export const PROPERTIES_ASSOCIATED = "Properties Associated";
export const ASSOCIATE_PROPERTY = "Associated Property";
export const SHOW_HIDE_PROPERTY = " Show/Hide Properties";
export const ASSOCIATE_INSTRUMENT = "Associate Instrument";
export const NO_CALCULATED_PROPERTY_SELECTED =
  "No Calculated Property Selected";
export const NO_PROPERTY_TYPE_SELECTED = "No Property Type Selected";
export const CALCULATED_PROPERTIES = "Calculated Properties";
export const GRADE_QUALITY_SPECS = "Grade Quality Specifications";
export const NO_GRADE_SELECTED = "No Grade Selected";
export const GRADE_SELECTION_CHANGE = "Grade selection change";
export const PRODUCT_QUALITY_SPECS = "Product Quality Specifications";
export const CALCULATED_PROPERTY_DEF = "Calculated Property definition";
export const LABEL_TOTALCOUNT = "Total counts";
export const LABEL_SELECT_FILTER = "Select & Filter";
export const LABEL_SEARCH = "Search";
export const LABEL_SEARCH_PROPERTY = "Search Property";
export const TARGET = "Target";
export const SIGMA = "Sigma";
export const SIGMA_PERCENT = "Sigma Percent";
export const ALARMLOWONE = "Alarm Low 1";
export const ALARMHIGHONE = "Alarm High 1";
export const ALARMLOWTWO = "Alarm Low 2";
export const ALARMHIGHTWO = "Alarm High 2";
export const REJECTLOW = "Reject Low";
export const REJECTHIGH = "Reject High";
export const GAIN = "Gain";
export const OFFSET = "Offset";
export const ORDER = "Order";
export const LABEL_AUTO_BACKUP = "Auto Backup";
export const LABEL_BACKUP_SUMMARY = "Backup Summary";
export const LABEL_BACKUP_NAME = "NAME";
export const LABEL_BACKUP_SIZE = "SIZE";
export const LABEL_BACKUP_DATE = "DATE";
export const LABEL_BACKUP_TIME = "TIME";
export const LABEL_BACKUP_STATUS = "STATUS";
export const LABEL_DATE_RANGE = "Date Range";
export const LABEL_DATE_MODIFIED = "Date Modified";
export const LABEL_TIME = "Time";
export const LABEL_PREFIX = "Prefix";
export const LABEL_BACKUP_LOCATION = "Backup Location";
export const LABEL_ALARM = "Alarm";
// Layout Titles
export const TITLE_TESTOVERVIEW = "Test Overview";
export const TITLE_MEASUREDPROPERTY = "Measured Property Type";
export const TITLE_KEYEDINPROPERTY = "Keyed-in Property Type";
export const TITLE_CALCULATEDPROPERTY = "Calculated Property Type";

export const TITLE_TESTOVERVIEW_GRAPH = "Graph";
export const TITLE_TESTOVERVIEW_DETAILS = "Details";
export const TITLE_TESTOVERVIEW_CONFIGURATION = "Configuration";
export const TITLE_TESTOVERVIEW_DASHBOARD = "Dashboard";
// Button Names
export const BUTTON_CREATE = "Create";
export const BUTTON_CLONE = "Clone";
export const BUTTON_COPY = "Copy";
export const BUTTON_CONFIRM = "Confirm";
export const BUTTON_HOME = "Home";
export const BUTTON_NEXT = "Next";
export const BUTTON_BACK = "Back";
export const BUTTON_CANCEL = "Cancel";
export const BUTTON_OK = "Ok";
export const BUTTON_SAVE = "Save";
export const BUTTON_MEASURE = "Measure";
export const BUTTON_STOP = "Stop";
export const BUTTON_START = "Start";
export const BUTTON_PAUSE = "Pause";
export const BUTTON_CLEAR_DATA = "Clear Data";
export const BUTTON_COMPLETE = "Complete";
export const BUTTON_REJECT = "Reject";
export const BUTTON_APPROVE = "Approve";
export const BUTTON_RESUME = "Resume";
export const BUTTON_ADD_PROPERTY = "Add Property";
export const BUTTON_ADD_SELECTED = "Add Selected";
export const BUTTON_RESTORE = "Restore";
export const BUTTON_INPROGRESS = "In-progress";
export const BUTTON_TEST = "Test";
export const BUTTON_REFRESH = "Refresh";
export const BUTTON_WAITING = "Waiting";
export const BUTTON_SKIP_COUNT = "Skip Count";
export const BUTTON_END_POSITION = "End Position";
export const ADD_GRADE = "Add Grade";
export const REMOVE_GRADE = "Remove Grade";
export const BUTTON_REMEASURE = "Re-measure";

//Grade Label Constants
export const LABLE_GRADE_CODE = "Grade Code";
export const LABLE_GRADE_STATE = "State";

// Instrument Lable Constants
export const LABLE_INSTRUMENT_CODE = "Instrument Code";
export const LABLE_INSTRUMENT_TYPE = "Instrument Type";
export const LABLE_INSTRUMENT_STATE = "State";
export const LABLE_INSTRUMENT_PORT = "Port#";
export const LABLE_INSTRUMENT_STATION = "Instrument Station";
export const LABLE_INSTRUMENT_IP = "IP Address";
export const LABLE_PORT = "Port";
export const LABLE_INSTRUMENT_USERNAME = "Username";
export const LABLE_INSTRUMENT_PASSWORD = "Password";
export const LABLE_AUTOLINE_FILES = "AutoLine Files";
export const LABLE_INSTRUMENT_DIRECTIONS = "Directions";
export const LABEL_INSTRUMENTDETAILS = "Instrument Details";
export const LABLE_NAME = "Name";
export const LABLE_GRADE_NAME = "Grade Name";
export const LABLE_ID = "ID";
export const LABLE_MIN = "Min";
export const LABLE_MAX = "Max";
export const LABLE_ADDITIONAL_INFORMATION = "Additional Information";
export const FROM_CONNECTED_INSTRUMENT = "From Connected Instrument";
export const FROM_INSTRUMENT_TYPE = "From Instrument Type";
export const CONNECTION_DETAILS = "Connection Details";
export const ENTER_XML_FILE = "Enter the XML File Path";
export const ENTER_FILE_NAME = "Enter the File Name";
export const SELECT_XML_FILE = "Select XML File Path";
export const SELECT_XML_PLACEHOLDER = "\\\\Server\\folder\\...";
export const LOCAL_BACKUP_FOLDER_PLACEHOLDER = "c:\\folder";
export const SFTP_FTP_BACKUP_FOLDER_PLACEHOLDER = "folder";
export const LIST_DIRECTORIES = "List of Directories or Files";
export const LIST_FILES = "List of Files";
export const BROWSE_FILE = "Browse File";
export const LABEL_BROWSE = "Browse";
export const FETCH_FILE = "Fetch File";
export const POLL_FRQ_SEC = "Polling Frequency (sec)";
export const POLL_FRQ = "Polling Frequency";
export const SERIAL_NO = "Serial Number";
export const CLONE_FROM = "CLONE FROM";
export const SAMPLE_STRIP_LENGTH = "SAMPLE STRIP LENGTH";
export const NO_OF_POSITION = "NUMBER OF POSITION";
export const NO_OF_COUNT = "NUMBER OF COUNT";
export const FIXED_POSITION_WIDTH = "FIXED POSITION WIDTH";
export const POSITION_WIDTH = "POSITION WIDTH";
export const DATE = "Date";
export const FORMULA_BELOW_INFO = "Variables should be wrapped in [ ]";
export const DESCRIPTION_BELOW_INFO = "Max. 200 characters";
export const REMARK_BELOW_INFO = "Max. 500 characters";
export const CONNECTION_TYPE = "Connection Type";
export const NETWORK = "Network";
export const INSTRUMENT_FILE_PATH = "File path";
export const GLOBAL_NO_OF_POSITION = "Global No. Of Position";
export const GLOBAL_NO_OF_COUNT = "Global No. Of Count";
export const GLOBAL_SAMPLE_STRIP_LENGTH = "Global Sample Strip Length";
export const GLOBAL_POSITION_COUNT_INFO =
  "This settings will apply globally to all Instruments, Keyed-In properties in the Test Plan.";
export const GLOBAL_POSITION_COUNT_DEFAULT_VALUE =
  "Default value of Positions, Counts and Strip length - 1, 1, 10000";

// Application Name
export const APP_NAME = "L&W Lab Management System";
export const BUILT = "Built On";
export const v = "v";

// Module Names
export const MODULE_PROPERTY = "Property";
export const MODULE_STATION = "Instrument Station";
export const MODULE_PRODUCT = "Product";
export const MODULE_INSTRUMENTTYPE = "Instrument Type";
export const MODULE_GRADE = "Grade";
export const MODULE_SOURCE = "Source";
export const MODULE_INSTRUMENT = "Instrument";
export const MODULE_TESTPLAN = "Test Plan";
export const MODULE_SAMPLE = "Sample";
export const MODULE_USERS = "Users";
export const MODULE_ROLES_AND_PERMISSIONS = "Roles & Permissions";
export const MODULE_REPORT_TEMPLATE = "Report Template";
export const MODULE_BACKUP_AND_RESTORE = "Backup and Restore Database";
export const MODULE_INSTRUMENT_DASHBOARD = "Instrument Dashboard";
export const MODULE_SETTINGS = "Settings";
export const MODULE_TRENDS = "Trends";
export const BUTTON_BACKUP = "Create Backup";
export const LMS_BACKUP_PREFIX = "LMS";
export const MODULE_SCANNER = "Scanner";
export const MODULE_DASHBOARD = "Dashboard";
export const MODULE_LOG_MODULE = "Module";
export const ROOT_URL = "/";

// PROPERTY URLS
export const PROPERTY_CREATE_URL = "/property/create";
export const PROPERTY_INDEX_URL = "/property";
export const PROPERTY_VIEW_ALL = "/property/viewall";

// STATION URLS
export const STATION_CREATE_URL = "/manageinstrument/instrumentstation/create";
export const STATION_INDEX_URL = "/manageinstrument/instrumentstation";
export const STATION_VIEW_ALL = "/manageinstrument/instrumentstation/viewAll";

// PRODUCT URLS
export const PRODUCT_CREATE_URL = "/product/create";
export const PRODUCT_INDEX_URL = "/product";
export const PRODUCT_VIEW_ALL = "/product/viewall";

// SOURCE URLS
export const SOURCE_CREATE_URL = "/source/create";
export const SOURCE_INDEX_URL = "/source";
export const SOURCE_VIEW_ALL = "/source/viewAll";

// INSTRUMENT TYPE URLS
export const INSTRUMENTTYPE_CREATE_URL =
  "/manageinstrument/instrumenttype/create";
export const INSTRUMENTTYPE_VIEW_ALL =
  "/manageinstrument/instrumenttype/viewall";
export const INSTRUMENTTYPE_INDEX_URL = "/manageinstrument/instrumenttype";
export const INSTRUMENTTYPE_ASSOCIATE_PROPERTY_URL =
  "/manageinstrument/instrumenttype/associate/property";

// GRADE URLS
export const GRADE_CREATE_URL = "/grade/create";
export const GRADE_INDEX_URL = "/grade";
export const GRADE_VIEW_ALL = "/grade/viewall";
export const GRADE_ASSOCIATE_PROPERTY_URL = "/grade/associate/property";

// INSTRUMENT URLS
export const INSTRUMENT_CREATE_URL = "/manageinstrument/instrument/create";
export const INSTRUMENT_INDEX_URL = "/manageinstrument/instrument";
export const INSTRUMENT_VIEW_ALL = "/manageinstrument/instrument/viewall";
export const INSTRUMENT_MEASUREMENT_INDEX_URL =
  "/manageinstrument/instrument/measurement/overview";

// TESTPLAN URLS
export const TESTPLAN_CREATE_URL = "/manageinstrument/testplan/create";
export const TESTPLAN_INDEX_URL = "/manageinstrument/testplan";
export const TESTPLAN_VIEW_ALL = "/manageinstrument/testplan/viewall";

// SAMPLE URLS
export const SAMPLE_CREATE_URL = "/sample/create";
export const SAMPLE_INDEX_URL = "/sample";
export const SAMPLE_INDEXNEW_URL = "/samplenew";
export const SAMPLE_VIEW_ALL = "/sample/viewall";
export const SAMPLENEW_VIEW_ALL = "/samplenew/viewall";
export const SAMPLE_REPORT = "/sample/report";
export const SAMPLENEW_REPORT = "/samplenew/report";

// measurement
export const MEASUREMENT_INDEX_URL = "/sample/measurement";
export const MEASUREMENT_OVERVIEW_URL = "/sample/overview";

// USER URLS
export const USER_CREATE_URL = "/accountmanagement/users/create";
export const USER_INDEX_URL = "/accountmanagement/users";
export const USER_VIEW_ALL = "/accountmanagement/users/viewall";

// REPORT URLS
export const REPORT_INDEX_URL = "/reporttemplate";
export const REPORT_CREATE_URL = "/reporttemplate/create";

//ROLES&PERMISSIONS URLS
export const ROLESANDPERMISSIONS_INDEX_URL =
  "/accountmanagement/rolesandpermissions";
export const ROLESANDPERMISSIONS_CREATE_URL =
  "/accountmanagement/rolesandpermissions/create";
export const ROLESANDPERMISSIONS_VIEW_URL =
  "/accountmanagement/rolesandpermissions/viiew";

// USER URLS
export const TRENDS_INDEX_URL = "/trends";

// UTILITY BACKUP&RESTORE URLS
export const UTILITY_INDEX_URL = "/utility/backupandrestore";
export const UTILITY_SETTING_INDEX_URL = "/utility/Settings";

//LOGS
export const LOGS_INDEX_URL = "/utility/Logs";

//LICENCE
export const LICENSE_MANAGEMENT_INDEX_URL = "/utility/LicenseManagement";
export const LICENSE_MANAGEMENT_TEXT1 = "Your active L&W Lab Management System license is valid until";
export const LICENSE_MANAGEMENT_LIFETIME = "Your active L&W Lab Management System license is a lifetime license for version";
export const LICENSE_MANAGEMENT_TEXT2 = "To continue using the software, please renew your license by adding an active license key in the field below.";
export const LICENCE_MANAGEMENT_SUPPORT_INFO = "If you require any support, contact our support team at";
export const LICENSE_STATUS = "Status";
export const LICENSE_EXPIRATION_DATE = "Expiration Date";
export const LICENSE_VERSION = "Version";
export const NO_SUBSCRIPTION_LICENSE_FOUND = "No Subscription License Found";
export const NO_LIFETIME_LICENSE_FOUND = "No Lifetime License Found";
export const LICENSE_ACTIVE = "Active";
export const LICENSE_INACTIVE = "Inactive";
export const LICENSE_SUBSCRIPTION = "Subscription License Details"
export const LICENSE_LIFETIME = "Lifetime License Details"

// Scanner Settings
export const SCANNER_CREATE_URL = "/utility/scanner/create";
export const SCANNER_INDEX_URL = "/utility/scanner";
export const SCANNER_VIEW_ALL = "/utility/scanner/viewall";
export const DASHBOARD_INDEX_URL = "/dashboard";

// INSTRUMENT DASHBOARD
export const INSTRUMENT_DASHBOARD_INDEX_URL = "/instrumentdashboard";
export const INSTRUMENT = "INSTRUMENT";
export const INSTRUMENT_TITLE = "INSTRUMENTS";
export const EVENTS = "EVENTS";
export const TOTAL_COUNTS = "TOTAL COUNTS";
export const CURRENTLY_MEASURING = "CURRENTLY MEASURING";
export const STATUS = "STATUS";
export const APPROVED_SAMPLE = "APPROVED SAMPLE";
export const REJECTED_SAMPLES = "REJECTED SAMPLES";
export const UPCOMING_EVENTS = "UPCOMING EVENTS";
export const LABEL_TOTAL = "Total";
export const LABEL_IN_USE = "In Use";
export const LABEL_AVAILABLE = "Available";
export const LABEL_NOT_AVAILABLE = "Not Available";

// STATE CONSTANTS
export const ENABLED = "Enabled";
export const DISABLED = "Disabled";

export const DELETE_TITLE = "Delete";
export const DELETE_MESSAGE = "Do you want to permanently delete the";
export const DELETE_ALL_MESSAGE =
  "Do you want to permanently delete the selected";
export const GRADES_DELETE = "Grades Deleted Successfully"
export const PRODUCTS_DELETE = "Products Deleted Successfully"
export const INSTRUMENT_DELETE = "Instrument Deleted Successfully"

export const RESTORE_TITLE = "Restore Confirm ?";
export const RESTORE_MESSAGE = "Do you want to restore ";
export const RESTORE_NOTE_MESSAGE = "Current database will be replaced by the";

// Property type constants
export const MEASURED = "Measured";
export const KEYED_IN = "Keyed In";
export const CALCULATED = "Calculated";

// Caclculated Constants
export const ASSIGN_THRESHOLD_VALUES = "Assign Threshold Values";
export const FORMULA_DEFINITION = "Formula Definition";
export const STEP1 = "Step 1";
export const STEP2 = "Step 2";

// Direction constants
export const ND = "--";
export const NOTCONSIDEREDFORCALC = "(--)";

// Notification Messages
export const INSTRUMENT_CONNECTION_DETAILS_NOT_FOUND =
  "Instrument connection details not found.";

// View All Constants
export const ALL_INSTRUMENTS = "All Instruments";
export const ALL_INSTRUMENTTYPES = "All Instrument Types";
export const ALL_PROPERTIES = "All Properties";
export const ALL_USERS = "All Users";
export const ALL_GRADES = "All Grades";
export const ALL_PRODUCTS = "All Products";
export const ALL_SOURCES = "All Sources";
export const ALL_STATIONS = "All Stations";
export const ALL_SAMPLES = "All Samples";
export const ALL_TESTPLANS = "All Test Plans";
export const SAMPLE_DELTE_WARNING =
  "Should not delete Measuring status of the sample";
export const SAMPLE_DATE = "Sample Date";
export const STATUS_ID = "StatusId";
export const GRADES = "Grades";
export const PRODUCTS = "Products";
export const TESTPLANS = "Test Plans";
// Value Report
// export const VALUE_REPORT = "Value Report";

//Autoline message
export const NOTE = "Note";
export const AUTOLINE_MESSAGE =
  "Positions will directly calculated in autoline while measuring.";
export const EXISTING_PROPERTY_MESSAGE =
  "Existing property specifications will be lost on changing Test Plan.";
export const GRADE_LOST_MESSAGE =
  "Once grade is saved all previous property specifications will be lost.";
export const DIRECTION_CHANGE_MAPPING_MESSAGE =
  "Direction change will clear all previous mappings.";
export const INSTRUMENT_TYPE_CHANGE_MAPPING_MESSAGE =
  "Instrument type change will clear all previous mappings.";
export const MAPPING_LOST_MESSAGE =
  "Once instrument is saved all previous mappings will be lost.";
export const PROPERTY_LOST_MESSAGE =
  "Existing property specifications will be lost on changing grade.";
export const PRODUCT_MAPPING_LOST_MESSAGE =
  "Once product is saved all previous property specifications will be lost.";
export const POSITION_CLEARED_MESSAGE = "Position(s) will be cleared for";
export const TESTPLAN_LOST_MESSAGE =
  "Once Test Plan is saved all previous position details will be lost.";
export const KEYEDIN_SELECTION_CHANGE_MESSAGE =
  "Keyed-In property selection change will clear position details.";
export const DELETE_POPUP_MESSAGE =
  "Once deleted, this item cannot be recovered.";
export const LOOSE_CURRENT_CHANGE_CHANGE_MESSAGE =
  "You will lose all your current changes from";
export const SAVE_MESSAGE =
  "If you prefer to save/retain then press Cancel button.";
export const NO_DATA_FOUND_MESSAGE = "(s) not found.";
export const DISPLAY_MESSAGE = "(s) to display.";
export const NO_DATA_MESSAGE = "No Data Found";
export const NO_BACKUP_DATA_MESSAGE = "No Backup files to restore";
export const WAITFOR_DATA_MESSAGE = "Please wait we are getting Backup files";

export const DIRECTION_MESSAGE =
  "Cant create Instrument as all directions are not mapped with properties";

export const MANDATORY_MESSAGE = 
  "Unable to create Instrument as mandatory fields are missing."

//loader
export const LOADING_INDICATOR = "loadingIndicator";
export const FORM_LOADING_INDICATOR = "formLoadingIndicator";

// error message shortcut grade/product create
export const NAME_OR_CODEID_REQUIRED = "Name or Code Id required";
export const ERROR_REQUIRED = "is required";
export const TEST_FAILED_FOLDER_CONNECTION =
  "Please check, Connection failed to the folder.";

export const SAMPLE_MEASUREMENT_PAUSE_MSG = "Measurement will be paused";
export const SAMPLE_MEASUREMENT_STOPPED_MSG = "Measurement will be stopped";
export const KEYEDIN_VALUE = "Please enter value";
export const KEYEDIN_VALUE_ERROR = "Enter valid value";
export const SAMPLE_MEASUREMENT_PAUSE_NOTIFICATION = "Measurement is paused";
export const SAMPLE_MEASUREMENT_STOPPED_NOTIFICATION = "Measurement is stopped";
export const SAMPLE_MEASUREMENT_REMEASURE_MSG =
  "All measurements will be reset";
export const SAMPLE_INSTRUMENT_REMEASURE_MSG =
  "Instrument measurement will be reset";
export const SAMPLE_INSTRUMENT_STOPPED_MSG =
  "Instrument measurement will be stopped";
export const SAMPLE_STARTING_MESSAGE = "Starting Measurement";
export const SAMPLE_REMEASURED_MESSAGE = "Sample Remeasured";
export const SAMPLE_APPROVED_MESSAGE = "Sample Approved";
export const SAMPLE_REJECTED_MESSAGE = "Sample Rejected";

export const SAMPLE_STOPPED_MESSAGE = "Sample Stopped";
export const SAMPLE_PAUSED_MESSAGE = "Sample Paused";
export const SAMPLE_RESUMED_MESSAGE = "Sample Resumed";
export const SAMPLE_CREATED_MESSAGE = "Sample Created";
export const SAMPLE_UPDATED_MESSAGE = "Sample Updated";
export const SAMPLE_DELETED_MESSAGE = "Sample Deleted";
export const SAMPLE_MEASUREMENT_SETACTIVE_MSG =  "Sample status will be reset to Measuring";
// Validation Errors
// Need to add inside translation files

export const NAME_VALIDATION_ERROR = "Value cannot contain special characters";
export const ID_VALIDATION_ERROR = "Value cannot contain special characters";
export const PROPERTY_ID_VALIDATION_ERROR = "Value cannot contain special characters or alphabets";
export const CODEID_VALIDATION_ERROR =
  "Value cannot contain special characters";
export const FIELD_EMPTY_ERROR = "Field cannot be empty";
export const IP_DUPLICATE_ERROR =
  "IP Address already associated with other instrument";
export const IP_VALIDATION_ERROR = "Invalid IP Address";
export const CUSTOMID_VALIDATION_ERROR = "ID Already Exists";
export const PORT_VALIDATION_ERROR = "Invalid port";
export const USERNAME_VALIDATION_ERROR = "Invalid username";
export const USERNAME_VALIDATION_DUPLICATE_ERROR = "Invalid username/Username already exists";
export const PASSWORD_VALIDATION_ERROR = "Invalid password";
export const FIRSTNAME_VALIDATION_ERROR = "Invalid firstname";
export const LASTNAME_VALIDATION_ERROR = "Invalid lastname";
export const EMAIL_VALIDATION_ERROR = "Invalid email";
export const DIR_VALIDATION_ERROR = "Invalid path";
export const FILENAME_VALIDATION_ERROR = "Invalid file name";
export const INSTRUMENT_NAME_VALIDATION_ERROR =
  "Value cannot contain special characters";
export const INSTRUMENT_CODE_VALIDATION_ERROR =
  "Value cannot contain special characters";
export const SERIAL_NO_VALIDATION_ERROR =
  "Value cannot contain special characters or alphabets";
export const INVALID_POSITION = "Invalid number of position(s).";
export const INVALID_COUNT = "Invalid count";
export const INVALID_FIXED_WIDTH = "Invalid fixed width";
export const ORDER_VALIDATION_ERROR = "Value should be grater than 0";

// Measurement New Meassage
export const MEASUREMENT_STOPPED_MESSAGE =
  "Once stopped all the property measurement will be stopped";
export const MEASUREMENT_PAUSED_MESSAGE =
  "Once paused all the property measurement will be paused";

// Grade Messages
export const MIN_MAX_ERROR = "Max value should be greater than min value";
export const REJECT_LOW_MIN_ERROR =
  "Reject Low Value should greater than Min values";
export const REJECT_HIGH_MAX_ERROR =
  "Reject High Value should less than Max values";
export const LOW_REJECT_LOW_ERROR = "Low2 Value should greater than Reject Low";
export const HIGH_REJECT_HIGH_ERROR =
  "High2 Value should less be than Reject High value";
export const LOW1_LOW2_ERROR = "Alarm Low 2 should be lower than Alarm Low 1";
export const HIGH1_HIGH2_ERROR = "Alarm High 2 should be higher than Alarm High 1";

export const ERROR_BOUNDARY_MSG =
  "There is an error loading this page. Please go back";

//dialog message (GRADE)
export const TESTPLAN_CHANGE_MSG = "Test Plan selection change";

export const TESTPLAN_DUPLICATE_POSITION = "Duplicate Position Name found.";
export const ALARM_LIMIT1_COLOR = "#F5BD00"; // Yellow
export const ALARM_LIMIT2_COLOR = "#FF7500"; // Orange
export const WITHIN_LIMIT_COLOR = "black"; // black
export const REJECT_LIMIT_COLOR = "red"; // RED
export const WITHIN_LIMIT_BG_COLOR = "transparent"; // RED

export const ValueRange: any = {
  WithinLimit: "Within Limit",
  RejectLimit: "Reject Limit",
  AlarmLimit1: "Alarm Limit1",
  AlarmLimit2: "Alarm Limit2",
};

export const TESTPLAN_NO_MEASURED_PROPERTY = "No Measured value is present";
export const TESTPLAN_NO_KEYEDIN_PROPERTY = "No Keyedin value is present";
export const NO_CALCULATED_PROPERTY = "No Calculated value is present";

// Login variables
export const LOGIN_USERNAME = "Username";
export const LOGIN_PASSWORD = "Password";
export const PRODUCT_NAME_WITH_VERSION = "LMS_v3.5.0";
export const REMEMBER_ME_TEXT = "Remember password";
export const FORGOT_PASSWORD = "Forgot password?";
export const LAW_TEXT =
  "This is a private system. Do not attempt to logon unless you are an authorized user. Any authorized or unauthorized access and use may be monitored and can resulting criminal or civil prosecution under applicable law.";
export const COPY_RIGHT_TEXT = "All Rights Reserved";
export const LOGIN_BUTTON = "Log in";
export const LOGIN_AUTH_SERVICE_DOWN = "OOPS! Authentication service is down!.";
export const LOGIN_TEXT_RUN = "Please run it under";
export const LOGIN_TEXT_START = "Please start it under";
export const TASK_SCHEDULER = "Task Scheduler";
export const TASK_SCHEDULER_LIBRARY = "Task Scheduler Library";
export const INVOKE_KEYCLOAK = "Invoke KeyCloak";
export const RUN = "Run"
export const SERVICES = "Services"
export const LMSIDENTITYSERVICE = "LMSIdentityService"
export const START = "Start"
export const KEYCLOAK_SCREEN_DISPLAY = "This screen is displayed since Keycloak needs to be configured for user.";
export const KEYCLOAK_MANUALLY_CONFIGURED = "If Keycloak is already configured manually,";
export const CLICK_HERE = "Click Here";
export const AVOID_SCREEN = "to avoid seeing this screen";
export const ENTER_KEYCLOAK_CREDENTIALS = "Enter the Keycloak Administrator credentials below to proceed with configuration";
export const KEYCLOAK_ADMIN_USERNAME = "Keycloak Admin Username";
export const KEYCLOAK_ADMIN_PASSWORD = "Keycloak Admin Password";
export const CONFIGURE_CREATE_NEW_USER_BUTTON = "Configure and Create Default User";
export const DEFAULT_USERNAME = "Default User Name";
export const DEFAULT_PASSWORD = "Default Password";
export const KEYCLOAK_NOTE = "Note:";
export const KEYCLOAK_SETUP = "Keycloak admin credentials should be setup by using";
export const KEYCLOAK_URL = "url.";
export const UPLOAD = "Upload";
export const SLA_UPLOAD_BUTTON = "Upload License File";
export const LICENSE_NOT_FOUND = "The L&W Lab Management System software requires a valid license.";
export const LICENSE_EXPIRED = "Your L&W Lab Management System license has expired as of";
export const LICENSE_EXPIRED_TEXT = "To continue using the software, please renew your license by adding an active license key in the field below.";
export const LICENCE_SUPPORT_INFO = "If you require any support, contact our support team at";
export const LICENSE_WARNING_HEADNG = "License Expiration Warning";
export const LICENSE_WARNING_TEXT1 = "Your L&W Lab Management System license will expire on {0} To avoid any disruption, update your license key in Configurations.";
export const LICENSE_WARNING_TEXT2 = "If you need a new license key or need support, contact our support team at lw.technicalsupport@se.abb.com";
export const LICENSE_COUNTER_TEXT1 = "Your L&W Lab Management System license expiring on {0} ";
export const LICENSE_COUNTER_TEXT2 = "you will be redirected to the login screen in";
export const CONFIGURATION_BUTTON  = "Go to Configuration";
export const LICENSE_SECONDS_TEXT = "seconds";
export const LIFETIME_LICENSE = "Lifetime";
export const FILE_UPLOAD_SUCCESS = "File uploaded successfully";
export const FILE_UPLOAD_FAILED = "File upload failed, Please try again with valid license file";

// Measurement Hub Retry Messages
export const RE_CONNECTING = "Hub is re-connecting, please Wait...";
export const RE_CONNECTED = "Hub re-connected.";

//Report
export const VALUE_REPORT = "Value Report";
export const REEL_REPORT = "Reel Report";
export const POSITION_REPORT = "Position Report";
export const GRAPH_REPORT = "Graph Report";

// ROLESANDPERMISSIONS
export const ADD_FEATURES = "Add Feature";
export const NO_TEMPLATE_SELECTED = "No Template Selected";
export const LANGUAGE_PREFERRED = "Language Preferred";
export const NO_LANGUAGE_PREFERRED = "No Language Preferred";
export const NO_ROLE_SELECTED = "No Role Selected";
export const USER_DETAILS = "User Details";
export const ROLE_DETAILS = "Role Details";
export const ROLE_NAME = "Role Name";
export const PERMISSIONS = "Permissions";
export const SEARCH_DOT = "Search...";
export const SELECT_ALL = "Select All";
export const ROLE_UPDATED = "Role Updated";
export const ALL_FEATURES = "All Features"
export const NO_ROLES_EDITED = "No Roles Edited!"

// VIEWALL USER
export const LABEL_FIRST_NAME = "First Name";
export const LABEL_LAST_NAME = "Last Name";
export const LABEL_LANGUAGE = "Language";
export const LABEL_ROLE = "Role";
export const LABEL_USERNAME = "User Name";
export const USER_PASSWORD = "Password is not mandatory while editing user informations";
export const MY_PROFILE = "My Profile";
export const EDIT_MY_PROFILE = "Edit My Profile";
export const CHANGE_PASSWORD = "Change Password";
export const OLD_PASSWORD = "Old Password";
export const NEW_PASSWORD = "New Password";
export const CONFIRM_PASSWORD = "Confirm Password";
export const USER_UPDATED = "User Updated";
export const PASSWORD_ERROR = "Password validation failed";
export const PASSWORD_OLD_NEW_ERROR = "Old and new Password Can't be same!";
export const PASSWORD_NEW_CONFIRM_ERROR = "Password and confirm password should be same!";
export const Description_Length = "character left out of 500 character";

export const FULL_SCREEN = "Full Screen";
export const EXIT_SCREEN = "Exit Screen";

// settings screen
export const LABLE_CT = "Measures of central tendency";
export const LABEL_MEDIAN = "Median";
export const LABEL_DEVIATION = "Deviation";
export const LABEL_STD = "Std";
export const LABEL_COV = "Cov";
export const LABLE_REPORT_HEAD = "Report Header 1";
export const LABEL_REPORT_SUBHEAD = "Report Header 2";
export const LABEL_FOOTER = "Report Footer";
export const LABEL_LOGO = "Logo";
export const LABEL_FILE_PREFIX = "Report File Name Prefix";
export const PLACEHOLDER_FILE_PREFIX = "Enter Prefix Name";
export const PDF_FORMAT_OPTION = "PDF";
export const EXCEL_FORMAT_OPTION = "Excel";
export const LABEL_LOCATION = "Location";
export const LABEL_GRAPH_TYPE = "Graph Type";
export const LABEL_SAVE_FORMAT = "Save Format";
export const LABEL_AUTO_REPORT = "RxD/TxD";
export const LABEL_AUTO_GENERATE_REPORT = "Auto Generate";
export const LABEL_POSITION_REPORT = "Position Report";
export const LABEL_GRAPH_REPORT = "Graph Report";
export const LABEL_VALUE_REPORT = "Value Report";
export const LABEL_REEL_REPORT = "Reel Report";
export const LABEL_IS_NETWORK_SHARED = "Is Network Shared";
export const LABEL_DOMAIN = "Domain";
export const LABEL_DRIVE = "Drive";
export const LABEL_IPADDRESS = "IP Address";
export const LABEL_PORT = "Port";

// Trends
export const LABEL_LIMIT = "Limit";
export const LABEL_YAXIS = "Y-Axis";

export const SELECT_LIMIT = "Select Limit";
export const SELECT_YAXIS = "Select Y-Axis";
export const SELECT_DATE_RANGE = "Select Date Range";
export const SELECT_GRADE = "Select Grade";
export const SELECT_PRODUCT = "Select Product";
export const SELECT_SAMPLE = "Select Sample";
export const SELECT_SOURCE = "Select Source";
export const PAGE_SIZE = 30;
export const PAGE_SIZE_ALL = 0;
export const SORT_SAMPLEDATE = "SampleDate";
export const SORT_CREATEDON = "CreatedOn";
export const SORT_TIMESTAMP = "TimeStamp";
export const SORT_ASC_ORDER = "Asc";
export const SORT_DESC_ORDER = "Desc";
export const SORT_ORDER = "Desc";
export const LABEL_CREATEDON = "Created On";
// Scanner
export const DELIMITER = "Delimiter";
export const SUBSTRING = "Substring";
export const LABEL_PROFILE_NAME = "Profile Name";
export const LABEL_SAMPLE_FIELDS = "Sample Fields";
export const LABEL_PICK_FIELDS = "Pick fields";
export const LABEL_PREVIEW = "Preview";
export const LABEL_MAPPINGS = "Mappings";
export const LABEL_KEY_FIELD = "Key Field";
export const LABEL_START_NUMBER = "Start Number";
export const LABEL_END_NUMBER = "End Number";
export const LABEL_FORMAT_TYPE = "Format Type";
export const LABEL_PROPERTIES_COUNT = "Associated properties count";
export const SUBSTRING_MESSAGE = "Substring Start Number will start from 0";
export const LABEL_MULTIMODE_INSTRUMENT_CONFIRM =
  "Would you like to {0} multimode instrument?";
export const LABEL_MULTIMODE_INSTRUMENT_MESSAGE =
  "You have {0} instrument(s) associated with address {1}, do you want to continue?";
export const LABEL_MULTIMODE_INSTRUMENT = "Multimode Instrument";
export const LABEL_MULTIMODE_INSTRUMENT_TEXT = "Multimode instrument.";
export const LABEL_OVERWRITE_MEASURED_VALUE = "Overwrite Measured Value";
export const LABEL_OVERWRITE_MEASURED_VALUE_CONFIRM =
  "Would you like to overwrite sample measured values?";
export const MEASURED_VALUE_LOST_MESSAGE =
  "Once edited values are saved, all previous measured values will be lost. Do you want to continue?";
export const LABEL_EDIT_PROPERTY_IN_USE = "Property in use";
export const LABEL_EDIT_PROPERTY_IN_USE_CONFIRM_TEXT1 = "Would you still like to edit the property values?";
export const LABEL_EDIT_PROPERTY_IN_USE_CONFIRM_TEXT2 = 
  "Once edited values are saved, property will be updated everywhere. Do you want to continue?";
export const LABEL_EDIT_PROPERTY_IN_USE_ = "Would you still like to edit the property values?";
export const EDIT_SAMPLE_SUCCESS= "Edited Sample Measurements updated";
export const NONE_EDITED = "No values got edited";
export const EDITED_MEASURED_VALUES_LOST = "Please Save or Cancel the edited values before making other changes.";
export const LABEL_CREATE = "create";
export const LABEL_UPDATE = "update";
export const INST_ORDER_TESTPLAN =
  "The selected instruments sequence will be used for measurement.";
export const KEYED_ORDER_TESTPLAN =
  "The selected keyedin properties sequence will be used for measurement.";
export const LABEL_MEASUREMENT_ORDER = "Measurement Order";
export const LABEL_INVALIDNETWORK_LOCATION = "Valid Network Location";
export const LABEL_INVALIDFOLDER_LOCATION = "Valid Folder Location";
export const LABEL_INVALIDPORT_LOCATION = "Valid Port";
export const LABEL_INVALIDIPADDRESS_LOCATION = "Valid Ip Address";
export const NO_IMAGE_FOUND = "No Image Found";
export const NO_TREND_DISPLAY = "No Trends to display";
export const NO_TREND_SELECT_PROPERTIES =
  "Select the Properties from the left panel to start seeing the trends.";
export const DATE_RANGES = [
  { value: 1, label: "Last Day" },
  { value: 2, label: "Last 7 days" },
  { value: 3, label: "Last 30 days" },
  { value: 4, label: "Custom Date" },
];
export const INSTRUMENT_MEASUREMENT_OVERVIEW =
  "/manageinstrument/instrument/measurement/overview";
export const NO_SAMPLES_FOUND = "No samples found for measurement";
export const SAMPLES_MEASUREMENT_NOT_STARTED =
  "Sample Measurement not started, start by clicking Play button";
export const SELECTED = "Selected";
export const FROM = "From";
export const TO = "To";
export const FROM_GRATER_TO = "From Date cannot be greater than To Date";
export const NO_PROPERTIES_MESSAGE = "No properties found on selected file.";

export const LABEL_STRIP_LENGTH = "Strip Length";
export const LABEL_CHOOSE_STRIP_LENGTH = "Choose Strip Length";
export const LABEL_GENERATE_XML = "Generate XML Files";

export const MODULE_REMARKS = "Remarks";
export const LABEL_MACHINE = "Machine";
export const LABEL_SOURCE = "Source";
export const LABEL_ADMIN = "Admin";
export const MSG_CURRENT_MEASURED_DATA =  "Please note that you will lose current measured data";
export const SAMPLE_MEASUREMENT_SETACTIVE_DATA ="Please note that setting status to measuring will allow remeasurement of all values, but it will not clear the measurement data automatically";

export const CLEAR_ALL_FILTERS = "Clear All Filters";

export const NO_PREVIEW_CONTENT = "No Preview Content";
export const SETTINGS_UPDATED_SUCCESSFULLY = "Settings Updated.";
export const TESTED_BACKUP_FOLDER_CONN = "Tested backup folder connection.";
export const LABEL_COPY_SELECTED_TO_RIGHT = "Copy Selected to Right";

export const PRODUCT_DELETED_MESSAGE = "Product Deleted";
export const GRADE_DELETED_MESSAGE = "Grade Deleted";
export const TEST_PLAN_DELETED_MESSAGE = "Test Plan Deleted";
export const INSTRUMENT_DELETED_MESSAGE = "Instrument Deleted";
export const SOURCE_DELETED_MESSAGE = "Source Deleted.";
export const PROPERTY_DELETED_MESSAGE = "Property Deleted.";
export const INSTRUMENT_TYPE_DELETED_MESSAGE = "Instrument Type Deleted";
export const INSTRUMENT_STATION_DELETED_MESSAGE = "Instrument Station Deleted";

export const APPROVED = "Approved";
export const REJECTED = "Rejected";

export const ACCESS_TOKEN = "access_token";
export const REFRESH_TOKEN = "refresh_token";
export const LOGOUT = "Logout";
export const LOGIN_URL = "/login";
export const SET_REMEMBER_ME = "remember_me";
export const SET_USERNAME = "userName";
export const LOGOUT_DIALOG_CONTENT = "Are you sure you want to Logout?";
export const BUTTON_CLOSE = "Close";
export const HAS_LOGGED_OUT = "hasLoggedOut";
export const PROPERTY_DETAILS_WILL_BE_RESET =
  "Property details will be reset!";

export const AUTHKEY_GRADE = "Grade";
export const AUTHKEY_INSTRUMENT = "Instrument";
export const AUTHKEY_INSTRUMENT_TYPE = "InstrumentType";
export const AUTHKEY_PRODUCT = "Product";
export const AUTHKEY_PROPERTY = "Property";
export const AUTHKEY_SAMPLE_MODE = "SampleMode";
export const AUTHKEY_SCANNER = "Scanner";
export const AUTHKEY_SOURCE = "Source";
export const AUTHKEY_INSTRUMENT_STATION = "InstrumentStation";
export const AUTHKEY_TEST_PLAN = "TestPlan";
export const AUTHKEY_SETTINGS = "Settings";
export const AUTHKEY_BACKUP_RESTORE = "BackupAndRestore";
export const AUTHKEY_INSTRUMENT_MODE = "InstrumentMode";
export const AUTHKEY_REPORT_TEMPLATE = "ReportTemplate";
export const AUTHKEY_TRENDS = "Trends";
export const AUTHKEY_USERS = "Users";
export const AUTHKEY_DASHBOARD = "Dashboard";
export const AUTHKEY_ROLES = "Roles";
export const AUTHKEY_LOGS = "Logs";
export const AUTHKEY_LICENSE_MANAGEMENT = "LicenseManagement";

